import React from 'react';
import styled from 'styled-components';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import DataGridPagination from './DataGridPagination';

const DataGridFooterContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

const DataGridFooter = () => {
  const { hasModule } = useDataSourceContext();
  const hasPaginationModule = hasModule('pagination');

  return (
    <DataGridFooterContainer>
      {hasPaginationModule && <DataGridPagination />}
    </DataGridFooterContainer>
  );
};

export default DataGridFooter;
